import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
import { TableComponent } from '../shared/table/table.component';
import { ItemModalComponent } from '../shared/item-modal/item-modal.component';
import { catchError, of } from 'rxjs';
interface InstitucionUpdate {
  id_institucion_educativa?: number; // Agregar esta propiedad
  clave?: string;
  fecha_creacion?: string;
  cod_mod?: string;
  cen_edu?: string;
  d_niv_mod?: string;
  tipssexo?: number;
  d_tipssexo?: string;
  gestion?: number;
  d_gestion?: string;
  ges_dep?: string;
  d_ges_dep?: string;
  director?: string;
  telefono?: string;
  email?: string;
  codcp_inei?: string;
  codccpp?: string;
  cen_pob?: string;
  area_censo?: number;
  dareacenso?: string;
  codgeo?: string;
  d_dpto?: string;
  d_prov?: string;
  d_dist?: string;
  estado?: string; // Agregar esta propiedad
}

@Component({
  selector: 'app-instituciones',
  standalone: true,
  imports: [CommonModule, FormsModule, TableComponent, ItemModalComponent],
  templateUrl: './instituciones.component.html',
  styleUrl: './instituciones.component.css',
})
export class InstitucionesComponent implements OnInit {
  instituciones: any[] = [];
  selectedItem: any = null;
  showModal: boolean = false;
  claveOriginal: string = '';
  fields: { key: string; label: string; type: string; options?: any }[] = [
    { key: 'clave', label: 'CLAVE', type: 'text' },
    { key: 'cod_mod', label: 'COD_MOD', type: 'text' },
    { key: 'cen_edu', label: 'CEN_EDU', type: 'text' },
    { key: 'd_niv_mod', label: 'D_NIV_MOD', type: 'text' },
    { key: 'tipssexo', label: 'TIPSSEXO', type: 'number' },
    { key: 'd_tipssexo', label: 'D_TIPSSEXO', type: 'text' },
    { key: 'gestion', label: 'GESTION', type: 'number' },
    { key: 'd_gestion', label: 'D_GESTION', type: 'text' },
    { key: 'ges_dep', label: 'GES_DEP', type: 'text' },
    { key: 'd_ges_dep', label: 'D_GES_DEP', type: 'text' },
    { key: 'director', label: 'DIRECTOR', type: 'text' },
    { key: 'telefono', label: 'TELEFONO', type: 'text' },
    { key: 'email', label: 'EMAIL', type: 'text' },
    { key: 'codcp_inei', label: 'CODCP_INEI', type: 'text' },
    { key: 'codccpp', label: 'CODCCPP', type: 'text' },
    { key: 'cen_pob', label: 'CEN_POB', type: 'text' },
    { key: 'area_censo', label: 'AREA_CENSO', type: 'number' },
    { key: 'dareacenso', label: 'DAREACENSO', type: 'text' },
    { key: 'codgeo', label: 'CODGEO', type: 'text' },
    { key: 'd_dpto', label: 'D_DPTO', type: 'text' },
    { key: 'd_prov', label: 'D_PROV', type: 'text' },
    { key: 'd_dist', label: 'D_DIST', type: 'text' },
  ];
  columns: { key: string; label: string }[] = [
    { key: 'id_institucion_educativa', label: 'ID' },
    { key: 'cod_mod', label: 'Codigo' },
    { key: 'cen_edu', label: 'Nombre' },
    { key: 'estado', label: 'Estado' },
  ];
  actions = [
    {
      class: 'bg-yellow-500 hover:bg-yellow-600 text-white py-1 px-3 rounded',
      icon: 'fas fa-edit',
      tooltip: 'Editar',
      // callback: (item: any) => this.editarItem(item),
      callback: (item: any) => this.openModal(item),
    },
    {
      class: 'bg-red-500 hover:bg-red-600 text-white py-1 px-3 rounded',
      tooltip: 'Eliminar',
      icon: 'fas fa-trash-alt',

      callback: (item: any) => this.eliminarItem(item),
      disabled: (item: any) => item.estado === 0,
    },
  ];
  formatInstitucion = (item: any) => ({
    clave: item.clave,
    cod_mod: item.cod_mod,
    cen_edu: item.cen_edu,
    d_niv_mod: item.d_niv_mod,
    tipssexo: item.tipssexo,
    d_tipssexo: item.d_tipssexo,
    gestion: item.gestion,
    d_gestion: item.d_gestion,
    ges_dep: item.ges_dep,
    d_ges_dep: item.d_ges_dep,
    director: item.director,
    telefono: item.telefono,
    email: item?.email,
    codcp_inei: item.codcp_inei,
    codccpp: item.codccpp,
    cen_pob: item.cen_pob,
    area_censo: item.area_censo,
    dareacenso: item.dareacenso,
    codgeo: item.codgeo,
    d_dpto: item.d_dpto,
    d_prov: item.d_prov,
    d_dist: item.d_dist,
  });

  constructor(private http: HttpClient, private router: Router) {}

  ngOnInit(): void {
    this.obtenerInstituciones();
  }

  obtenerInstituciones(): void {
    this.http
      .get<any[]>(environment.apiUrl + '/institucion-educativa')
      .subscribe(
        (response) => {
          //console.log(response);
          this.instituciones = response.map((item) => ({
            ...item,
            clave: '',
          }));
        },
        (error) => {
          console.error('Error al obtener las instituciones:', error);
        }
      );
  }

  verDetalles(institucion: any): void {
    this.router.navigate(['/institucion'], {
      queryParams: {
        id_institucion_educativa: institucion.id_institucion_educativa,
      },
    });
  }
  eliminarInstitucion(id: number): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.http
          .delete(environment.apiUrl + `/institucion-educativa/${id}`)
          .subscribe(
            () => {
              Swal.fire(
                'Eliminado',
                'La institución ha sido eliminada.',
                'success'
              );
              this.obtenerInstituciones(); // Refresca la lista
            },
            () => {
              Swal.fire(
                'Error',
                'No se pudo eliminar la institución.',
                'error'
              );
            }
          );
      }
    });
  }
  openModal(item: any) {
    //console.log('Editar:', item);
    this.selectedItem = {
      ...item,
    };
    this.showModal = true;
  }

  goBack(): void {
    this.router.navigate(['/main']);
  }

  goToCreateInstituciones(): void {
    this.router.navigate(['/create-instituciones']);
  }

  goToCreateInstitucion(): void {
    this.router.navigate(['/create-institucion']);
  }
  eliminarItem(item: any) {
    Swal.fire({
      title: 'Eliminar Estudiante',
      text: '¿Estas seguro de eliminar la estudiante?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.http
          .delete(`${environment.apiUrl}/institucion-educativa/${item.id_institucion_educativa}`)
          .subscribe(
            () => {
              Swal.fire(
                'Eliminado',
                'La institución ha sido eliminada.',
                'success'
              );
              this.obtenerInstituciones(); // Refresca la lista
            },
            (error) => {
              console.error('Error al eliminar la institución:', error);
              Swal.fire({
                title: 'Error',
                text:
                  error.error.message || 'No se pudo eliminar la institución.',
                icon: 'error',
              });
            }
          );
      }
    });
  }

  saveChanges(updatedItem: any) {
    Swal.fire({
      title: 'Guardar cambios',
      text: '¿Estás seguro de guardar los cambios?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        // Crear el objeto de datos para la actualización
        const institucionData: InstitucionUpdate = { ...updatedItem };

        delete institucionData.id_institucion_educativa;
        delete institucionData.estado;
        delete institucionData.fecha_creacion;

        if (!institucionData.email || institucionData.email.trim() === '') {
          delete institucionData.email; // No enviar el campo si está vacío
        } else if (!this.validateEmail(institucionData.email)) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'El correo electrónico no es válido.',
          });
          return; // Detener el proceso si el correo no es válido
        }
        //console.log('Telefono:', institucionData.telefono);
        if (!institucionData.telefono || institucionData.telefono.trim() === '') {
          delete institucionData.telefono; // No enviar el campo si está vacío
        }

        // Verificar si la clave ha cambiado
        if (updatedItem.clave && updatedItem.clave !== this.claveOriginal) {
          institucionData.clave = updatedItem.clave;
        } else {
          delete institucionData.clave; // No enviar la clave si no ha cambiado
        }

        //console.log('Datos a enviar:', institucionData);

        // Enviar la solicitud de actualización al servidor
        this.http
          .patch(
            `${environment.apiUrl}/institucion-educativa/${updatedItem.id_institucion_educativa}`,
            institucionData
          )
          .pipe(
            catchError((error) => {
              console.error('Error al guardar los cambios:', error);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.error.message || 'Error al guardar los cambios',
              });
              return of(null); // Retornar un observable nulo en caso de error
            })
          )
          .subscribe((response) => {
            if (response) {
              Swal.fire({
                icon: 'success',
                title: 'Cambios guardados con éxito',
                text: 'Los cambios se guardaron correctamente.',
              }).then(() => {
                this.showModal = false;
                this.obtenerInstituciones(); // Refrescar la lista de instituciones
              });
            }
          });
      }
    });
  }

  validateEmail(email: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }
}
